<template>

    <!-- Carousel Component -->
    <Carousel v-if="this.setCarouselImageData.length > 1" :carouselData="this.setCarouselImageData" />

	<!-- Single Slide Component -->
	<SingleSlide v-else :carouselData="this.setCarouselImageData" />

</template>

<script>

import Carousel from './components/Carousel.vue';
import SingleSlide from './components/SingleSlide.vue'

export default {

  	name: 'App',

  	components: { 
		  
		Carousel,

		SingleSlide

	},

  	beforeMount() {

		// Gets the image urls for desktop to be used by the carousel
		this.getCarouselImageData();
		
	},

	data() {

		return {

			// Array to store the image data for desktop
			carouselData: '',

		}

	},

	computed: {

		// Sets the retrieved data from getCarouselImageData
		setCarouselImageData: function() {

			// Retrieves the data for the carousel to be used on desktop
			return this.carouselData

		},

	},

  	methods: {

		// Gets the state data for carouselData
		getCarouselImageData() {

			// Searches for the div on the page with an id of "carouselData"
			const arr = document.getElementById('carouselData');

			// Turns the content of the div into a string
			const arr2 = arr.textContent;

			// Parses the string into an array
			const arr3 = JSON.parse(arr2);

			// Sets the state for carouselData with the array
			this.carouselData = arr3;

		}

  	}

}

</script>

<style></style>
